import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sid = match?.[1];
    if (!sid) { navigate("/", { replace: true }); return; }

    (async () => {
      try {
        const code = sessionStorage.getItem("uaicard_invite_code") || undefined;
        const { data } = await api.post("/auth/session", { session_id: sid, invite_code: code });
        sessionStorage.removeItem("uaicard_invite_code");
        if (data.session_token) localStorage.setItem("session_token", data.session_token);
        setUser(data.user);
        const target = data.user?.role === "owner" ? "/admin" : data.user?.role === "docente" ? "/docente" : (data.user?.role === "staff" && data.user?.staff_kind === "coordinacion") ? "/direccion" : (data.user?.role === "staff" && data.user?.staff_kind === "enfermeria") ? "/enfermeria" : "/dashboard";
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true, state: { user: data.user } });
      } catch (e) {
        const detail = e.response?.data?.detail || "No se pudo iniciar sesión.";
        sessionStorage.setItem("uaicard_auth_error", detail);
        sessionStorage.removeItem("uaicard_invite_code");
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-nardo-50">
      <div className="text-nardo-500 uppercase tracking-[0.3em] text-xs">Procesando inicio de sesión…</div>
    </div>
  );
}
